import { Modal } from "antd";
import { useState, useEffect } from "react";
import { useMobxStores } from "../../../stores/stores";
import { observer } from "mobx-react";

const ListForSaleModal = ({
  ownershipObj,
  listingObj,
  isOpen,
  handleClose,
}) => {
  const [quantity, setQuantity] = useState(1);
  const [totalPrice, setTotalPrice] = useState(listingObj?.total_price);
  // const [quantity, setQuantity] = useState(5);
  // const [totalPrice, setTotalPrice] = useState(0.0002);
  const [isHovered, setIsHovered] = useState(false);
  const { marketplaceStore, userStore } = useMobxStores();

  useEffect(() => {
    let listingObj = marketplaceStore.listings.find(
      (obj) => obj.seller_username === userStore.user.email
    );
    if (listingObj) {
      setQuantity(listingObj.quantity);
      setTotalPrice(listingObj.total_price);
    } else {
      setQuantity(0);
      setTotalPrice(0);
      if (marketplaceStore.NFT?.supply === 1) {
        setQuantity(1);
      }
    }
  }, []);

  useEffect(() => {
    setTotalPrice(listingObj?.total_price);
  }, [listingObj, ownershipObj]);

  const handleQuantityChange = (value) => {
    const numericValue = value.replace(/[^0-9]/g, "");

    setQuantity(Math.min(Number(numericValue), ownershipObj?.quantity));
  };

  const handleTotalPriceChange = (value) => {
    const numericValue = value.replace(/[^0-9.]/g, "");

    setTotalPrice(numericValue);
  };

  const handleSave = async () => {
    if (marketplaceStore.NFT?.supply > 1) {
      if (!quantity || !totalPrice) {
        return;
      }
    } else {
      if (!totalPrice) {
        return;
      } else {
        setQuantity(1);
      }
    }

    const payload = {
      seller: ownershipObj?.owner,
      nft: ownershipObj?.nft,
      quantity: quantity,
      total_price: totalPrice,
      active: true,
    };

    if (listingObj) {
      marketplaceStore.PatchListing(listingObj.id, payload);
    } else {
      marketplaceStore.PostListing(payload);
    }

    await marketplaceStore.UpdateNFT(ownershipObj?.nft, {
      listed: true,
      price: totalPrice,
    });
    marketplaceStore.setNFTIsSelling(true);
    handleClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={280}
      styles={{ content: { padding: "20px 16px" } }}
      title={
        <span
          style={{
            color: "#000080",
            fontWeight: "600",
            fontSize: "20px",
          }}
        >
          List for sale
        </span>
      }
    >
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
        }}
        onSubmit={(e) => {
          console.log("jijiji");
          e.preventDefault();
          handleSave();
        }}
      >
        {marketplaceStore.NFT?.supply === 1 ? (
          <></>
        ) : (
          <>
            {ownershipObj?.quantity > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "90%",
                }}
              >
                <label
                  htmlFor="quantity"
                  style={{
                    marginBottom: "5px",
                    fontSize: "18px",
                    fontWeight: "400",
                  }}
                >
                  Quantity
                </label>
                <input
                  name="quantity"
                  onChange={(e) => handleQuantityChange(e.target.value)}
                  style={{
                    width: "112px",
                    height: "28px",
                    border: "none",
                    outline: "none",
                    backgroundColor: "#D9D9D9",
                    borderRadius: "0px",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                  value={quantity}
                />
              </div>
            )}
          </>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "90%",
          }}
        >
          <label
            htmlFor="totalPrice"
            style={{ marginBottom: "5px", fontSize: "18px", fontWeight: "400" }}
          >
            Total Price
          </label>
          <input
            name="totalPrice"
            value={totalPrice}
            onChange={(e) => handleTotalPriceChange(e.target.value)}
            style={{
              width: "112px",
              height: "28px",
              border: "none",
              outline: "none",
              backgroundColor: "#D9D9D9",
              borderRadius: "0px",
              boxSizing: "border-box",
              textAlign: "center",
            }}
          />
        </div>
        {marketplaceStore.NFT?.supply > 1 ? (
          <button
            type="submit"
            disabled={!quantity || !totalPrice}
            onMouseOver={() => setIsHovered(true)}
            onFocus={() => setIsHovered(true)}
            onMouseOut={() => setIsHovered(false)}
            onBlur={() => setIsHovered(false)}
            style={{
              width: "126px",
              height: "32px",
              border: "none",
              outline: "none",
              backgroundColor:
                !quantity || !totalPrice
                  ? "#CFCFCF"
                  : isHovered
                  ? "#000099"
                  : "#000080",
              borderRadius: "10px",
              color: !quantity || !totalPrice ? "#A0A0A0" : "white",
              fontSize: "20px",
              cursor: !quantity || !totalPrice ? "default" : "pointer",
            }}
          >
            Save
          </button>
        ) : (
          <button
            type="submit"
            disabled={!totalPrice}
            onMouseOver={() => setIsHovered(true)}
            onFocus={() => setIsHovered(true)}
            onMouseOut={() => setIsHovered(false)}
            onBlur={() => setIsHovered(false)}
            style={{
              width: "126px",
              height: "32px",
              border: "none",
              outline: "none",
              backgroundColor: !totalPrice
                ? "#CFCFCF"
                : isHovered
                ? "#000099"
                : "#000080",
              borderRadius: "10px",
              color: !totalPrice ? "#A0A0A0" : "white",
              fontSize: "20px",
              cursor: !totalPrice ? "default" : "pointer",
            }}
          >
            Save
          </button>
        )}
      </form>
    </Modal>
  );
};

export default observer(ListForSaleModal);
